import { render, staticRenderFns } from "./ModalInfoProduct.vue?vue&type=template&id=54cb280e&scoped=true"
import script from "./ModalInfoProduct.vue?vue&type=script&lang=js"
export * from "./ModalInfoProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoProduct.vue?vue&type=style&index=0&id=54cb280e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb280e",
  null
  
)

export default component.exports